__turbopack_context__.v({
  "collapsed": "chatHistoryPanel-module-scss-module__DC6X2W__collapsed",
  "header": "chatHistoryPanel-module-scss-module__DC6X2W__header",
  "heading": "chatHistoryPanel-module-scss-module__DC6X2W__heading",
  "listArea": "chatHistoryPanel-module-scss-module__DC6X2W__listArea",
  "panel": "chatHistoryPanel-module-scss-module__DC6X2W__panel",
  "railActions": "chatHistoryPanel-module-scss-module__DC6X2W__railActions",
  "railFadeIn": "chatHistoryPanel-module-scss-module__DC6X2W__railFadeIn",
});
